import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

import { useCreateContact } from "@/hooks/mutations";

const contactUsSchema = z.object({
  subject: z.string().min(1, "Required"),
  message: z.string().min(1, "Required"),
});

export const ContactUsForm = ({
  handleBack,
  handleSuccess,
}: {
  handleBack: () => void;
  handleSuccess: () => void;
}) => {
  const { mutate: createContact, status } = useCreateContact();

  const form = useForm({
    defaultValues: {
      subject: "",
      message: "",
    },
    resolver: zodResolver(contactUsSchema),
  });

  const handleSubmit = (data: z.infer<typeof contactUsSchema>) => {
    createContact(
      { createContactRequest: data },
      {
        onSuccess: () => {
          handleSuccess();
        },
      },
    );
  };

  return (
    <Form {...form}>
      <form
        className="flex flex-col gap-6"
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onSubmit={form.handleSubmit(handleSubmit)}
      >
        {/* Subject */}
        <div className="flex flex-col gap-4">
          <FormField
            control={form.control}
            name="subject"
            render={({ field }) => (
              <FormItem className="text-slate-700">
                <FormLabel>Subject</FormLabel>
                <FormControl>
                  <Input
                    placeholder="What would you like help with?"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        {/* Message */}
        <div className="flex flex-col gap-4">
          <FormField
            control={form.control}
            name="message"
            render={({ field }) => (
              <FormItem className="text-slate-700">
                <FormLabel>Message</FormLabel>
                <FormControl>
                  <Textarea className="h-[292px] resize-none" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        <div className="flex items-center justify-end gap-2">
          <Button
            className="rounded-full"
            onClick={handleBack}
            type="button"
            variant="secondary"
          >
            Back
          </Button>
          <Button
            className="rounded-full"
            disabled={status === "pending"}
            type="submit"
          >
            Send Message
          </Button>
        </div>
      </form>
    </Form>
  );
};
